import React from 'react'
import {
  Super,
  Heading1,
  Heading2,
  Heading3,
  Heading4,
  Title,
  TextBody,
  Cta,
  Label,
} from '../../styles/vars/textStyles.style'

const ThisSuper = ({ children, as, color, maxWidth, ...props }) => (
  <Super as={as} color={color} maxWidth={maxWidth} {...props}>
    {children}
  </Super>
)

const ThisHeading1 = ({ children, as, color, maxWidth, ...props }) => (
  <Heading1 as={as} color={color} maxWidth={maxWidth} {...props}>
    {children}
  </Heading1>
)

const ThisHeading2 = ({ children, as, color, maxWidth, ...props }) => (
  <Heading2 as={as} color={color} maxWidth={maxWidth} {...props}>
    {children}
  </Heading2>
)

const ThisHeading3 = ({ children, as, color, maxWidth, ...props }) => (
  <Heading3 as={as} color={color} maxWidth={maxWidth} {...props}>
    {children}
  </Heading3>
)

const ThisHeading4 = ({ children, as, color, maxWidth, ...props }) => (
  <Heading4 as={as} color={color} maxWidth={maxWidth} {...props}>
    {children}
  </Heading4>
)

const ThisTitle = ({ children, as, color, maxWidth, ...props }) => (
  <Title as={as} color={color} maxWidth={maxWidth} {...props}>
    {children}
  </Title>
)

const ThisTextBody = ({ children, as, color, maxWidth, ...props }) => (
  <TextBody as={as} color={color} maxWidth={maxWidth} {...props}>
    {children}
  </TextBody>
)

const ThisCta = ({ children, as, color, textTransform, maxWidth, ...props }) => (
  <Cta as={as} color={color} textTransform={textTransform} maxWidth={maxWidth} {...props}>
    {children}
  </Cta>
)

const ThisLabel = ({ children, as, color, bgColor, maxWidth, ...props }) => (
  <Label as={as} color={color} bgColor={bgColor} maxWidth={maxWidth} {...props}>
    {children}
  </Label>
)

export {
  ThisSuper as Super,
  ThisHeading1 as Heading1,
  ThisHeading2 as Heading2,
  ThisHeading3 as Heading3,
  ThisHeading4 as Heading4,
  ThisTitle as Title,
  ThisTextBody as TextBody,
  ThisCta as Cta,
  ThisLabel as Label,
}
